module.exports = __webpack_public_path__ + "static/media/corsica.a9d8fe21.png";